import { render } from "./subAppMain.vue?vue&type=template&id=df5cc492"
import script from "./subAppMain.vue?vue&type=script&lang=js"
export * from "./subAppMain.vue?vue&type=script&lang=js"

import "./subAppMain.vue?vue&type=style&index=0&id=df5cc492&lang=less"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__